import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import Home from "./pages/Home";
import Sales from "./pages/Sales";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Tw from "./pages/Tw";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/tw" exact component={Tw} />
          <Route path="/sales" exact component={Sales} />
          <Route path="/login" exact component={Login} />
          <Route path="/signup" exact component={Signup} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;
